/** @jsxImportSource @emotion/react */
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import SportsEsportsOutlinedIcon from "@mui/icons-material/SportsEsportsOutlined";
import appLogo from "../../assets/images/svg/appLogo.svg";
import { useGetAppBarStyles } from "./index.styles";
import { Bingo_Url } from "../../connections";
import Bingo from "./../../assets/images/Bingo.png";
import { Col, Container, Row } from "react-bootstrap";
import BingoFloatingButton from "../BingoFloatingButton";

const PUBLIC_ROUTES = [
  "/signup",
  "/complete-profile",
  "/signup-aws",
  "/signup1",
  "/singnup",
];

const AppBar = ({
  navItems,
  locationPill,
  actionIcons,
  onDrawerHandler,
  drawerWidth = 0,
  pageTitle,
  variant,
}) => {
  const location = useLocation();
  const classes = useGetAppBarStyles();
  const navigate = useNavigate();

  useEffect(() => {
    const isAuthenticated = JSON.parse(localStorage.getItem("auth") || "false");

    if (!isAuthenticated && !PUBLIC_ROUTES.includes(location?.pathname)) {
      navigate("/login");
    }
  }, [location?.pathname, navigate]);

  const isMenu = location?.pathname === "/home" ? true : false;
  const isSubPage = !isMenu;

  const refreshFun = () => {
    setTimeout(() => {
      if (JSON.parse(localStorage.getItem("auth"))) {
        navigate("/home");
      }
    }, 500);
  };
  const [mobileView, setMobileView] = useState(false);

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 767
        ? setMobileView(true)
        : setMobileView(false);
    };
    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);
  const showHomeHeader = variant === "home" && !isSubPage && mobileView;

  return (
    <>
      <header
        css={[
          showHomeHeader ? classes.homeHeader : classes.header,
          { zIndex: 1251, marginBottom: isSubPage ? 20 : 0 },
        ]}
      >
        {showHomeHeader && (
          <>
            <div css={classes.homeHeaderRow}>
              <img
                css={classes.homeLogo}
                src={appLogo}
                alt="money mails logo"
                onClick={() => refreshFun()}
              />
              <nav css={classes.homeNav}>
                <IconButton
                  component="a"
                  href={Bingo_Url}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Bingo"
                  sx={{ backgroundColor: "rgba(255,255,255,0.18)" }}
                >
                  <SportsEsportsOutlinedIcon sx={{ color: "#fff" }} />
                </IconButton>
                {actionIcons}
              </nav>
            </div>
            <div css={classes.homeLocationRow}>{locationPill}</div>
          </>
        )}
        {!showHomeHeader && mobileView ? (
          <Container
            className={classes.header}
            style={{ zIndex: 1251, padding: 0 }}
          >
            <Row style={{ width: "100%", alignItems: "center" }}>
              <Col
                xs={isSubPage && pageTitle ? 2 : "auto"}
                style={{ padding: isSubPage && pageTitle ? "0 10px" : "0 4px" }}
              >
                {isSubPage && pageTitle ? (
                  <IconButton
                    size="large"
                    edge="start"
                    aria-label="back"
                    sx={{
                      color: "#fff",
                      backgroundColor: "rgba(255,255,255,0.12)",
                      borderRadius: "50%",
                      width: 40,
                      height: 40,
                      transition: "all 0.2s ease",
                      "&:hover": {
                        backgroundColor: "rgba(255,255,255,0.22)",
                        transform: "translateY(-1px)",
                      },
                    }}
                    onClick={() => navigate(-1)}
                  >
                    <ArrowBackIosNewIcon sx={{ fontSize: "1.2rem" }} />
                  </IconButton>
                ) : (
                  <div css={classes.mobileLogos}>
                    <img
                      css={classes.logom}
                      height={35}
                      src={appLogo}
                      alt="money mails logo"
                      onClick={() => refreshFun()}
                    />
                    <a href={Bingo_Url} target="_blank" rel="noreferrer">
                      <img
                        css={classes.logo}
                        height={32}
                        src={Bingo}
                        alt="Bingo logo"
                      />
                    </a>
                  </div>
                )}
              </Col>
              {isSubPage && pageTitle ? (
                <Col
                  xs={6}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span
                    style={{
                      color: "#fff",
                      fontSize: "1rem",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {pageTitle}
                  </span>
                </Col>
              ) : null}
              <Col
                xs={isSubPage && pageTitle ? 4 : "auto"}
                style={{
                  padding: isSubPage && pageTitle ? "0" : "0 4px",
                  flex: isSubPage && pageTitle ? undefined : "1 1 auto",
                  minWidth: 0,
                }}
              >
                {navItems ? <nav css={classes.nav}>{navItems}</nav> : null}
              </Col>
            </Row>
          </Container>
        ) : null}
        {!showHomeHeader && !mobileView && (
          <>
            {isSubPage && pageTitle ? (
              <IconButton
                size="large"
                edge="start"
                aria-label="back"
                sx={{
                  mr: 2,
                  color: "#fff",
                  backgroundColor: "rgba(255,255,255,0.12)",
                  borderRadius: "50%",
                  width: 42,
                  height: 42,
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.22)",
                    transform: "translateY(-1px)",
                  },
                }}
                onClick={() => navigate(-1)}
              >
                <ArrowBackIosNewIcon sx={{ fontSize: "1.3rem" }} />
              </IconButton>
            ) : (
              window.innerWidth > 768 &&
              isMenu && (
                <IconButton
                  size="large"
                  edge="start"
                  aria-label="menu"
                  sx={{
                    mr: 2,
                    color: "#fff",
                    backgroundColor: "rgba(255,255,255,0.12)",
                    borderRadius: "50%",
                    width: 42,
                    height: 42,
                    transition: "all 0.2s ease",
                    "&:hover": {
                      backgroundColor: "rgba(255,255,255,0.22)",
                      transform: "translateY(-1px)",
                    },
                  }}
                  onClick={onDrawerHandler}
                >
                  <MenuIcon sx={{ fontSize: "1.5rem" }} />
                </IconButton>
              )
            )}
            {!mobileView && (
              <img
                css={classes.logo}
                height={35}
                src={appLogo}
                alt="money mails logo"
                onClick={() => refreshFun()}
              />
            )}
            {mobileView && (
              <img
                css={classes.mobilelogo}
                height={35}
                src={appLogo}
                alt="money mails logo"
                onClick={() => refreshFun()}
              />
            )}
            <a href={Bingo_Url} target="_blank" rel="noreferrer">
              <img
                css={classes.logo}
                height={32}
                src={Bingo}
                alt="Bingo logo"
                style={{
                  marginLeft: "15px",
                  verticalAlign: "middle",
                  marginTop: "-5px",
                }}
              />
            </a>
  
            {isSubPage && pageTitle && (
              <span
                style={{
                  color: "#fff",
                  fontSize: "1.1rem",
                  fontWeight: 600,
                  position: "absolute",
                  left: "50%",
                  transform: "translateX(-50%)",
                  whiteSpace: "nowrap",
                  pointerEvents: "none",
                }}
              >
                {pageTitle}
              </span>
            )}
  
            {navItems ? <nav css={classes.nav}>{navItems}</nav> : null}
          </>
        )}
      </header>
      <BingoFloatingButton />
    </>
  );
};

export default AppBar;
